import React from 'react';
import { BillingMonth } from '../../types';
import { formatCentsAsDollars } from '../../utils/money';
import { formatNumber } from '../admin/shared';
import { TableCard, TableHeader, TableViewport, thClass, tdClass } from '../table/TableKit';

// Frozen monthly bills, newest first. Shared by the user Billing tab and the admin instance billing page.
function BillingMonthsTable({ months }: { months: BillingMonth[] }) {
  if (months.length === 0) {
    return <p className="text-sm text-secondary">No billed months yet. A month appears here after it ends.</p>;
  }
  return (
    <TableCard>
      <TableHeader title="Monthly billing" />
      <TableViewport>
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-700">
              {['Month', 'Usage', 'Credits', 'Amount due'].map((label) => <th key={label} className={thClass}>{label}</th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {months.map((month) => (
              <tr key={month.month}>
                <td className={tdClass}>{new Date(`${month.month}-01T00:00:00Z`).toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' })}</td>
                <td className={tdClass}>
                  {formatCentsAsDollars(month.cost_cents)}
                  <span className="block text-xs text-secondary">{formatNumber(month.input_tokens_converted)} tokens</span>
                </td>
                <td className={tdClass}>
                  {month.credit_cents > 0 && '−'}{formatCentsAsDollars(month.credit_cents)}
                  <span className="block text-xs text-secondary">{formatNumber(month.credit_tokens_applied)} tokens</span>
                </td>
                <td className={tdClass}>{formatCentsAsDollars(month.billed_cents)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableViewport>
    </TableCard>
  );
}

export default BillingMonthsTable;
